import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { Button } from '@/components/common/UI/Button'
import { Card } from '@/components/common/UI/Card'

interface TelegramSettingsData {
  linked: boolean
  username: string | null
  notification_enabled: boolean
}

export const TelegramSettings = () => {
  const queryClient = useQueryClient()
  const { data } = useQuery({
    queryKey: ['telegram', 'settings'],
    queryFn: () => apiClient.get<TelegramSettingsData>('/v1/telegram/settings'),
  })
  const link = useMutation({
    mutationFn: () => apiClient.post<{ url: string }>('/v1/telegram/link'),
    onSuccess: (result) => window.open(result.url, '_blank', 'noopener,noreferrer'),
  })
  const update = useMutation({
    mutationFn: (enabled: boolean) => apiClient.put('/v1/telegram/settings', { notification_enabled: enabled }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['telegram', 'settings'] }),
  })

  return (
    <Card className="mt-4 p-5">
      <h3 className="font-semibold">Telegram уведомления</h3>
      <p className="mt-1 text-sm text-secondary-600">Получайте сообщения об изменении статусов откликов и приглашениях на интервью.</p>
      {data?.linked ? (
        <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
          <span className="text-sm">Аккаунт связан{data.username ? `: @${data.username}` : ''}</span>
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={data.notification_enabled} disabled={update.isPending} onChange={(event) => update.mutate(event.target.checked)} />Уведомления включены</label>
        </div>
      ) : (
        <Button className="mt-4" disabled={link.isPending} onClick={() => link.mutate()}>{link.isPending ? 'Создаём ссылку…' : 'Связать Telegram'}</Button>
      )}
      {link.isError && <p className="mt-2 text-sm text-error">Не удалось создать ссылку. Проверьте настройки Telegram-бота.</p>}
      {update.isError && <p className="mt-2 text-sm text-error">Не удалось сохранить настройки уведомлений.</p>}
    </Card>
  )
}
